/* eslint-disable import/order */
import React from 'react';
import { useLocation } from 'react-router';
import './boot-shell.sass';
import Loader from 'shared-components/helper-components/loader/loader';
import LayoutShell from '@pano-project/components/Layout/MainLayout/LayoutShell';
import { getLayoutClassNames } from '@pano-project/components/Layout/MainLayout/layout-class-names';
import BootHeader from '@pano-project/components/CashierHeader/BootHeader';
import { useBootHeaderSettings } from '@pano-project/components/CashierHeader/useBootHeaderSettings';
import { useHeaderElements } from '@pano-project/components/CashierHeader/useHeaderElements';
import { bootThemeVariables } from '@pano-project/variables/boot-theme-variables';
import { resolveBootPage } from 'utils/helper-functions/get-landing-page';

interface BootShellProps {
  text?: string | false;
  showLoaderIcon?: boolean;
}

const BootShell = (props: BootShellProps) => {
  const {
    supportsTabs,
    showAnyHeaderButton,
    headerStyle,
    layout,
    appearanceMode,
    isPreselectedPM,
  } = useBootHeaderSettings();
  const { pathname } = useLocation();
  const { showPaymentType, showBalance, balance } = useHeaderElements({
    currentPage: resolveBootPage(pathname),
  });

  const hasHeaderContent = showAnyHeaderButton || showPaymentType || !!balance;

  if (!supportsTabs || !hasHeaderContent) return <Loader {...props} />;

  bootThemeVariables.inject(appearanceMode);

  const className = `${getLayoutClassNames({
    layout,
    headerStyle,
    appearanceMode,
    showHeaderButtons: showAnyHeaderButton,
    showBalance,
    isPreselectedPM,
  })} _boot-shell`;

  return (
    <LayoutShell className={className}>
      <BootHeader />
      <Loader {...props} />
    </LayoutShell>
  );
};

export default BootShell;
